// use-fetch-data.js
import { useEffect, useState } from "react";
import { GET_TECHNICALDEPUTY_IMPLEMENETONTRACTLIST } from "helpers/url_helper";
import { APIClient } from "helpers/api_helper";

const api = new APIClient();

interface Contract {
  projectId: number;
  contractNumber: string;
  date: string;
  price: number;
  customerName: string;
  approvedByTechincalDeputy: boolean;
  id: number;
}

interface Contracts {
  impContracts: Contract[];
}

let val: Contracts;

const useFetchData = () => {
  const [data, setData] = useState(val);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchData = async () => {
      try {
        await api
          .get(GET_TECHNICALDEPUTY_IMPLEMENETONTRACTLIST, null)
          .then((response) => {
            setData(JSON.parse(JSON.stringify(response)));
            setLoading(false);
          });
      } catch (error) {
        console.error(error);
      }
    };

    fetchData();
  }, []);

  return {
    data,
    loading,
  };
};

export default useFetchData;
